import type { PropsWithChildren } from "react";

import { Button, Modal } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { useAllCompetitorsModal } from "./AllCompetitorsModalContext";

const customModalStyles = {
    content: {
        width: "938px",
    },
    overlay: {
        /**
         * The "highcharts-tooltip-container" z-index redefined inside app/routes/SwLayout.tsx as "z-index: 1056 !important;"
         * So we need to use some z-index less than 1056, but higher or the same as SideBarContainer which is 1055
         */
        zIndex: 1055,
    },
};

export const AllCompetitorsModal = ({ children }: PropsWithChildren) => {
    const translate = useTranslation();
    const { isOpen, openModal, closeModal } = useAllCompetitorsModal();

    return (
        <>
            <Button
                type="flat"
                onClick={openModal}
                data-automation="see-all-competitors-button"
            >
                {translate("bt.report.channels.see-all-competitors-button.text")}
            </Button>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                customStyles={customModalStyles}
                data-automation="all-competitors-modal"
            >
                {children}
                <Modal.Footer withBorder>
                    <Button
                        onClick={closeModal}
                        data-automation="close-all-competitors-button"
                    >
                        {translate("common.close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
